<template>
    <div class="video-status">
        <Select2 v-model="videostatus" :options="videoStatusOptions" :settings="{placeholder: 'Select Status'}" @change="applyChange($event)"></Select2>
    </div>
</template>

<script>
    import Select2 from 'v-select2-component';
    import axios from 'axios';
    export default {
        props: ['currentstatus', 'vfoid'],
        components: {Select2},
        data() {
            return {
                videoStatusOptions:
                    [
                        {id:'Canceled', text: 'Canceled' },
                        {id:'Deleted', text: 'Deleted' },
                        {id:'Upload Successful', text: 'Upload Successful' },
                        {id:'Under Review', text: 'Under Review' },
                        {id:'Need More Info', text: 'Need More Info' },
                        {id:'Video Approved', text: 'Video Approved' },
                        {id:'Uploading', text: 'Uploading', disabled: true },
                        {id:'Upload Failed', text: 'Upload Failed', disabled: true },
                        {id:'Closed Caption File', text: 'Closed Caption File', disabled: true },
                        {id:'Processing', text: 'Processing', disabled: true  },
                        {id:'Processing Failed', text: 'Processing Failed', disabled: true },
,                    ],
                videostatus: this.currentstatus,
            }
        },
        methods: {
            applyChange: function() {
                let that = this;
                // console.log('appl')
                let actionUrl = '/video/update/' + that.vfoid;
                axios(
                    {
                        method: 'POST',
                        url: actionUrl,
                        params: {
                            status: that.videostatus
                        }
                    }).catch(function (error) {
                    // handle error
                    console.log('This is the error returned', error);
                });
            }
        }
    }
</script>
